import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function CTABand() {
  return <section className="py-24 border-t border-white/10 relative overflow-hidden" data-id="element-50">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-51">
        <img src="https://cdn.magicpatterns.com/uploads/jvXfG7ELiuPdgcREkpuLtn/WhoWeServe-bg.png" alt="Small town street scene" className="absolute inset-0 w-full h-full object-cover" data-id="element-52" />
        <div className="absolute inset-0 bg-atomic-black/75" data-id="element-53" />
        <div className="absolute inset-0 bg-gradient-to-b from-atomic-black/90 via-atomic-black/75 to-atomic-black/90" data-id="element-54" />
      </div>

      {/* Abstract Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-atomic-green/5 to-transparent z-0" data-id="element-55"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-r from-atomic-black/50 to-transparent z-0" data-id="element-56"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-57">
        {/* Location strip */}
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-58">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center p-3 bg-atomic-green/10 rounded-full mb-6 border border-atomic-green/20" data-id="element-59">
            <MapPin className="w-6 h-6 text-atomic-green" data-id="element-60" />
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-61">
            Based in Morrice, MI — serving and shipping nationwide
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-400 leading-relaxed" data-id="element-62">
            Supporting businesses, teams, and organizations across the U.S. with
            fast, reliable production and delivery.
          </motion.p>
        </div>

        {/* CTA */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10" data-id="element-63">
          <div className="text-center lg:text-left max-w-2xl" data-id="element-64">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-65">
              Ready to <span className="text-atomic-green" data-id="element-66">Print?</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-xl text-gray-300" data-id="element-67">
              Ready to print custom apparel that works as hard as you do? Get
              started with a local shop that understands teams, trades, and
              tight deadlines.
            </motion.p>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto" data-id="element-68">
            <a href="/contact" data-id="element-69">
              <Button size="lg" className="w-full sm:w-auto text-lg px-10" data-id="element-70">
                Get a Quote
              </Button>
            </a>
            <a href="/contact" data-id="element-71">
              <Button variant="outline" size="lg" className="w-full sm:w-auto text-lg px-10" data-id="element-72">
                Contact Us
              </Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}